export default "__VITE_ASSET__aba3428a__"